// extracted by mini-css-extract-plugin
export default {"SocialLoginButton":"socialLoginButton_SocialLoginButton__nSxrw","SocialIcon":"socialLoginButton_SocialIcon__JkaK0"};